<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Role Details">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="functionInfos" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Function" id="input-" size="sm" :model.sync="model.functionInfoId"   :selected="model.functionInfo != null ? model.functionInfo.name : ''" @input="getFunctionInfos" />
				<b-form-group id="fieldset-allow-create" label-cols-lg="12" label="Allow Create" label-for="input-allow-create">
						<b-form-checkbox id="input-allow-create" v-model="model.allowCreate"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-read" label-cols-lg="12" label="Allow Read" label-for="input-allow-read">
						<b-form-checkbox id="input-allow-read" v-model="model.allowRead"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-update" label-cols-lg="12" label="Allow Update" label-for="input-allow-update">
						<b-form-checkbox id="input-allow-update" v-model="model.allowUpdate"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-delete" label-cols-lg="12" label="Allow Delete" label-for="input-allow-delete">
						<b-form-checkbox id="input-allow-delete" v-model="model.allowDelete"></b-form-checkbox>
					</b-form-group>
					</b-col>
					<b-col cols="12" lg="6">
				<b-form-group id="fieldset-show-in-menu" label-cols-lg="12" label="Show In Menu" label-for="input-show-in-menu">
						<b-form-checkbox id="input-show-in-menu" v-model="model.showInMenu"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-download" label-cols-lg="12" label="Allow Download" label-for="input-allow-download">
						<b-form-checkbox id="input-allow-download" v-model="model.allowDownload"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-print" label-cols-lg="12" label="Allow Print" label-for="input-allow-print">
						<b-form-checkbox id="input-allow-print" v-model="model.allowPrint"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-upload" label-cols-lg="12" label="Allow Upload" label-for="input-allow-upload">
						<b-form-checkbox id="input-allow-upload" v-model="model.allowUpload"></b-form-checkbox>
					</b-form-group>

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import RoleDetail from '@/models/Role/RoleDetail';
import RoleDetailFilter from '@/filters/Role/RoleDetailFilter';

import Role from '@/models/Role/Role';
import RoleFilter from '@/filters/Role/RoleFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import FunctionInfo from '@/models/FunctionInfo/FunctionInfo';
import FunctionInfoFilter from '@/filters/FunctionInfo/FunctionInfoFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			functionInfos : [],
			isBusy: false,
		}
	},
	methods : {
		getRoleDetail : async function(id) {
			this.isBusy = true;
			RoleDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getFunctionInfos();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getRoleDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getFunctionInfos();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getRoleDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
